/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as presetV1 from "./keyapis_preset_preset_v1.pb"

/**
 * События пресетов
 */

/**
 * Сервис событий пресетов
 */
export class EventServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод установки пресета.
   * Метод доступен для: admin, service
   */
  PostEventPresetInstall = (req: PostEventPresetInstallRequestDto, init?: RequestInit): Promise<PostEventPresetInstallResponseDto> => {
    return fm.request<PostEventPresetInstallRequestDto, PostEventPresetInstallResponseDto>(`${this.host}/preset/api/v1/event/preset/${encodeURIComponent(req.id)}/install`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос на установку пресета
 */
export type PostEventPresetInstallRequestDto = {
  /**
   * Идентификатор пресета
   */
  id: number
}
/**
 * Ответ на запрос на установку пресета
 */
export type PostEventPresetInstallResponseDto = {
}
/**
 * Задача ошибки при конфигурации устройства.
 * Очередь key.preset.configuration_fail
 */
export type PresetConfigurationFailTaskRequestDto = {
  /**
   * Идентификатор ответа
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Идентификатор пресета
   */
  presetId: number
  /**
   * Текст ошибки
   */
  errorMessage: string
}
/**
 * Задача ошибки при конфигурации устройства.
 * Очередь key.preset.configuration_fail
 */
export type PresetConfigurationFailTaskResponseDto = {
  /**
   * Идентификатор ответа
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Идентификатор пресета
   */
  presetId: number
  /**
   * Текст ошибки
   */
  errorMessage: string
}
/**
 * Задача успешной конфигурации устройства.
 * Очередь key.preset.configuration_success
 */
export type PresetConfigurationSuccessTaskRequestDto = {
  /**
   * Идентификатор ответа
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Идентификатор пресета
   */
  presetId: number
  /**
   * Дата и время конфигурации
   */
  configuredAt: string
}
/**
 * Задача успешной конфигурации устройства.
 * Очередь key.preset.configuration_success
 */
export type PresetConfigurationSuccessTaskResponseDto = {
  /**
   * Идентификатор ответа
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Идентификатор пресета
   */
  presetId: number
  /**
   * Дата и время конфигурации
   */
  configuredAt: string
}
/**
 * Задача на конфигурирование устройства.
 * Очередь key.preset.configuration
 */
export type PresetConfigurationTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Пресет
   */
  preset: presetV1.PresetRequestDto
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Модель
   */
  model: string
  /**
   * Адрес устройства
   */
  host: string
  /**
   * Имя пользователя устройства
   */
  username: string
  /**
   * Пароль пользователья устройства
   */
  password: string
  /**
   * Таймзона NTP
   */
  ntpTimezone: string
}
/**
 * Задача на конфигурирование устройства.
 * Очередь key.preset.configuration
 */
export type PresetConfigurationTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Пресет
   */
  preset: presetV1.PresetResponseDto
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Модель
   */
  model: string
  /**
   * Адрес устройства
   */
  host: string
  /**
   * Имя пользователя устройства
   */
  username: string
  /**
   * Пароль пользователья устройства
   */
  password: string
  /**
   * Таймзона NTP
   */
  ntpTimezone: string
}
/**
 * Задача на установку пресета.
 * Очередь key.preset.install
 */
export type PresetInstallTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Пресет
   */
  preset: presetV1.PresetRequestDto
}
/**
 * Задача на установку пресета.
 * Очередь key.preset.install
 */
export type PresetInstallTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Пресет
   */
  preset: presetV1.PresetResponseDto
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на установку пресета
   */
  "PostEventPresetInstallRequest": {
    "kind": "class",
    "text": "Запрос на установку пресета",
    "fields": {
      /**
       * Идентификатор пресета
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор пресета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на установку пресета
   */
  "PostEventPresetInstallResponse": {
    "kind": "class",
    "text": "Ответ на запрос на установку пресета",
  },
  /**
   * Задача ошибки при конфигурации устройства.
   * Очередь key.preset.configuration_fail
   */
  "PresetConfigurationFailTask": {
    "kind": "class",
    "text": "Задача ошибки при конфигурации устройства.\nОчередь key.preset.configuration_fail",
    "fields": {
      /**
       * Идентификатор ответа
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор ответа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор пресета
       */
      "presetId": {
        "type": "int32",
        "text": "Идентификатор пресета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Текст ошибки
       */
      "errorMessage": {
        "type": "string",
        "text": "Текст ошибки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача успешной конфигурации устройства.
   * Очередь key.preset.configuration_success
   */
  "PresetConfigurationSuccessTask": {
    "kind": "class",
    "text": "Задача успешной конфигурации устройства.\nОчередь key.preset.configuration_success",
    "fields": {
      /**
       * Идентификатор ответа
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор ответа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор пресета
       */
      "presetId": {
        "type": "int32",
        "text": "Идентификатор пресета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата и время конфигурации
       */
      "configuredAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время конфигурации",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на конфигурирование устройства.
   * Очередь key.preset.configuration
   */
  "PresetConfigurationTask": {
    "kind": "class",
    "text": "Задача на конфигурирование устройства.\nОчередь key.preset.configuration",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пресет
       */
      "preset": {
        "type": "Preset",
        "text": "Пресет",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Модель
       */
      "model": {
        "type": "string",
        "text": "Модель",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Адрес устройства
       */
      "host": {
        "type": "string",
        "text": "Адрес устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя пользователя устройства
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пароль пользователья устройства
       */
      "password": {
        "type": "string",
        "text": "Пароль пользователья устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Таймзона NTP
       */
      "ntpTimezone": {
        "type": "string",
        "text": "Таймзона NTP",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на установку пресета.
   * Очередь key.preset.install
   */
  "PresetInstallTask": {
    "kind": "class",
    "text": "Задача на установку пресета.\nОчередь key.preset.install",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пресет
       */
      "preset": {
        "type": "Preset",
        "text": "Пресет",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}